import { render } from "./RetailerOverView.vue?vue&type=template&id=27fcd402&scoped=true"
import script from "./RetailerOverView.vue?vue&type=script&lang=js"
export * from "./RetailerOverView.vue?vue&type=script&lang=js"

import "./RetailerOverView.vue?vue&type=style&index=0&id=27fcd402&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fcd402"]])

export default __exports__